export default "assets/images/icons/avantages-677bce29.svg";